/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  NodataBatchDeleteReqVo,
  NodataDiscardReqVo,
  NodataPageReqVo,
  NodataReturnOrderReqVo,
  NodataUpdateReqVo,
  ResponseBoolean,
  ResponseIPageNodataPageItemResVo,
  ResponseInteger,
  ResponseNodataInfoResVo,
  ResponseNodataManualInfoUserResVo,
  ResponseNodataReturnOrderResVo,
  ResponsePageDataNodataClientPackageItemResVo,
  ResponsePageDataNodataReturnGoodsDto,
} from '../models/index';
import {
    NodataBatchDeleteReqVoFromJSON,
    NodataBatchDeleteReqVoToJSON,
    NodataDiscardReqVoFromJSON,
    NodataDiscardReqVoToJSON,
    NodataPageReqVoFromJSON,
    NodataPageReqVoToJSON,
    NodataReturnOrderReqVoFromJSON,
    NodataReturnOrderReqVoToJSON,
    NodataUpdateReqVoFromJSON,
    NodataUpdateReqVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseIPageNodataPageItemResVoFromJSON,
    ResponseIPageNodataPageItemResVoToJSON,
    ResponseIntegerFromJSON,
    ResponseIntegerToJSON,
    ResponseNodataInfoResVoFromJSON,
    ResponseNodataInfoResVoToJSON,
    ResponseNodataManualInfoUserResVoFromJSON,
    ResponseNodataManualInfoUserResVoToJSON,
    ResponseNodataReturnOrderResVoFromJSON,
    ResponseNodataReturnOrderResVoToJSON,
    ResponsePageDataNodataClientPackageItemResVoFromJSON,
    ResponsePageDataNodataClientPackageItemResVoToJSON,
    ResponsePageDataNodataReturnGoodsDtoFromJSON,
    ResponsePageDataNodataReturnGoodsDtoToJSON,
} from '../models/index';

export interface NodataBatchDeletePostRequest {
    nodataBatchDeleteReqVo?: NodataBatchDeleteReqVo;
}

export interface NodataClientPackagesGetRequest {
    scene: number;
    warehouseId: number;
    currentPage?: number;
    pageSize?: number;
    ownerType?: number;
    startTime?: string;
    endTime?: string;
    trackingNumber?: string;
}

export interface NodataDeletePostRequest {
    id: number;
}

export interface NodataDiscardPostRequest {
    nodataDiscardReqVo?: NodataDiscardReqVo;
}

export interface NodataInfoGetRequest {
    id: number;
}

export interface NodataManualInfoUserGetRequest {
    coupangInboundCode: string;
}

export interface NodataPagePostRequest {
    nodataPageReqVo?: NodataPageReqVo;
}

export interface NodataReturnGoodsGetRequest {
    id: number;
    keyword: string;
    currentPage?: number;
    pageSize?: number;
}

export interface NodataReturnOrderPostRequest {
    nodataReturnOrderReqVo?: NodataReturnOrderReqVo;
}

export interface NodataUpdateManualInfoPostRequest {
    nodataUpdateReqVo?: NodataUpdateReqVo;
}

/**
 * 
 */
export class NodataControllerApi extends runtime.BaseAPI {

    /**
     * NODATA·按国家批量删除旧无数据
     * NODATA·按国家批量删除旧无数据
     */
    async nodataBatchDeletePostRaw(requestParameters: NodataBatchDeletePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseInteger>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nodata/batch-delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NodataBatchDeleteReqVoToJSON(requestParameters['nodataBatchDeleteReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseIntegerFromJSON(jsonValue));
    }

    /**
     * NODATA·按国家批量删除旧无数据
     * NODATA·按国家批量删除旧无数据
     */
    async nodataBatchDeletePost(requestParameters: NodataBatchDeletePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseInteger> {
        const response = await this.nodataBatchDeletePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·无数据包裹分页
     * 客户端·无数据包裹分页
     */
    async nodataClientPackagesGetRaw(requestParameters: NodataClientPackagesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataNodataClientPackageItemResVo>> {
        if (requestParameters['scene'] == null) {
            throw new runtime.RequiredError(
                'scene',
                'Required parameter "scene" was null or undefined when calling nodataClientPackagesGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling nodataClientPackagesGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['scene'] != null) {
            queryParameters['scene'] = requestParameters['scene'];
        }

        if (requestParameters['ownerType'] != null) {
            queryParameters['ownerType'] = requestParameters['ownerType'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        if (requestParameters['trackingNumber'] != null) {
            queryParameters['trackingNumber'] = requestParameters['trackingNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nodata/client-packages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataNodataClientPackageItemResVoFromJSON(jsonValue));
    }

    /**
     * 客户端·无数据包裹分页
     * 客户端·无数据包裹分页
     */
    async nodataClientPackagesGet(requestParameters: NodataClientPackagesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataNodataClientPackageItemResVo> {
        const response = await this.nodataClientPackagesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * NODATA·删除单个无数据
     * NODATA·删除单个无数据
     */
    async nodataDeletePostRaw(requestParameters: NodataDeletePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling nodataDeletePost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nodata/delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * NODATA·删除单个无数据
     * NODATA·删除单个无数据
     */
    async nodataDeletePost(requestParameters: NodataDeletePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.nodataDeletePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * NODATA·废弃无数据
     * NODATA·废弃无数据
     */
    async nodataDiscardPostRaw(requestParameters: NodataDiscardPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nodata/discard`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NodataDiscardReqVoToJSON(requestParameters['nodataDiscardReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * NODATA·废弃无数据
     * NODATA·废弃无数据
     */
    async nodataDiscardPost(requestParameters: NodataDiscardPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.nodataDiscardPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 手机端·无数据信息获取
     * 手机端·无数据信息获取
     */
    async nodataInfoGetRaw(requestParameters: NodataInfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseNodataInfoResVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling nodataInfoGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nodata/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseNodataInfoResVoFromJSON(jsonValue));
    }

    /**
     * 手机端·无数据信息获取
     * 手机端·无数据信息获取
     */
    async nodataInfoGet(requestParameters: NodataInfoGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseNodataInfoResVo> {
        const response = await this.nodataInfoGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 根据 Coupang 预约入库编号查询补登时可回填的会员编号。 按 Coupang 预约入库编号查询无数据补登会员编号
     * 按 Coupang 预约入库编号查询无数据补登会员编号
     */
    async nodataManualInfoUserGetRaw(requestParameters: NodataManualInfoUserGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseNodataManualInfoUserResVo>> {
        if (requestParameters['coupangInboundCode'] == null) {
            throw new runtime.RequiredError(
                'coupangInboundCode',
                'Required parameter "coupangInboundCode" was null or undefined when calling nodataManualInfoUserGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['coupangInboundCode'] != null) {
            queryParameters['coupangInboundCode'] = requestParameters['coupangInboundCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nodata/manual-info-user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseNodataManualInfoUserResVoFromJSON(jsonValue));
    }

    /**
     * 根据 Coupang 预约入库编号查询补登时可回填的会员编号。 按 Coupang 预约入库编号查询无数据补登会员编号
     * 按 Coupang 预约入库编号查询无数据补登会员编号
     */
    async nodataManualInfoUserGet(requestParameters: NodataManualInfoUserGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseNodataManualInfoUserResVo> {
        const response = await this.nodataManualInfoUserGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * NODATA·无数据分页列表
     * NODATA·无数据分页列表
     */
    async nodataPagePostRaw(requestParameters: NodataPagePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseIPageNodataPageItemResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nodata/page`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NodataPageReqVoToJSON(requestParameters['nodataPageReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseIPageNodataPageItemResVoFromJSON(jsonValue));
    }

    /**
     * NODATA·无数据分页列表
     * NODATA·无数据分页列表
     */
    async nodataPagePost(requestParameters: NodataPagePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseIPageNodataPageItemResVo> {
        const response = await this.nodataPagePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 在拍照页按当前包裹会员搜索所有历史订单商品。 手机端·无数据返送历史商品搜索
     * 手机端·无数据返送历史商品搜索
     */
    async nodataReturnGoodsGetRaw(requestParameters: NodataReturnGoodsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataNodataReturnGoodsDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling nodataReturnGoodsGet().'
            );
        }

        if (requestParameters['keyword'] == null) {
            throw new runtime.RequiredError(
                'keyword',
                'Required parameter "keyword" was null or undefined when calling nodataReturnGoodsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nodata/return-goods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataNodataReturnGoodsDtoFromJSON(jsonValue));
    }

    /**
     * 在拍照页按当前包裹会员搜索所有历史订单商品。 手机端·无数据返送历史商品搜索
     * 手机端·无数据返送历史商品搜索
     */
    async nodataReturnGoodsGet(requestParameters: NodataReturnGoodsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataNodataReturnGoodsDto> {
        const response = await this.nodataReturnGoodsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 提交前可编辑选择列表，提交后同一包裹只返回原返送单。 手机端·无数据包裹生成待定返送订单
     * 手机端·无数据包裹生成待定返送订单
     */
    async nodataReturnOrderPostRaw(requestParameters: NodataReturnOrderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseNodataReturnOrderResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nodata/return-order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NodataReturnOrderReqVoToJSON(requestParameters['nodataReturnOrderReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseNodataReturnOrderResVoFromJSON(jsonValue));
    }

    /**
     * 提交前可编辑选择列表，提交后同一包裹只返回原返送单。 手机端·无数据包裹生成待定返送订单
     * 手机端·无数据包裹生成待定返送订单
     */
    async nodataReturnOrderPost(requestParameters: NodataReturnOrderPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseNodataReturnOrderResVo> {
        const response = await this.nodataReturnOrderPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 手机端·无数据快递用户信息登记
     * 手机端·无数据快递用户信息登记
     */
    async nodataUpdateManualInfoPostRaw(requestParameters: NodataUpdateManualInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/nodata/update-manual-info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NodataUpdateReqVoToJSON(requestParameters['nodataUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 手机端·无数据快递用户信息登记
     * 手机端·无数据快递用户信息登记
     */
    async nodataUpdateManualInfoPost(requestParameters: NodataUpdateManualInfoPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.nodataUpdateManualInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
